export const loginConstants = {
  LOGIN: "USERS_LOGIN",
  LOGOUT: "USERS_LOGOUT",
  ADMIN_TOKEN: "ADMIN_TOKEN",
  LOGIN_STATUS: {
    SUCCESS: 0,
  },
  ROLE: "Role",
  ROLE_ID: "RoleId",
  BRAND_ID: "BrandId",
  GROUP_ID: "groupId",
  FRANCHISE_ID: "FranchiseId",
  CUSTOMER_ID: "customerId",
  ORDER_ID: "orderId",
  CONVERSATION_ID: "conversationId",
  LOCATION_ID: "LocationId",
  MANAGER_ID: "ManagerId",
  LOGIN_SPINNER: "LOGIN_SPINNER",
  FORGOT_SPINNER: "FORGOT_SPINNER",
  RESET_PASSWORD_SPINNER: "RESET_PASSWORD_SPINNER",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  RESET_FORGOT_PASSWORD_RESPONSE: "RESET_FORGOT_PASSWORD_RESPONSE",
  EMAIL_SENT_MESSAGE: "Email successfully sent!",
  TYPE_PASSWORD: "password",
  TYPE_CONFIRM_PASSWORD: "confirmPassword",
  RESET_PASSWORD: "RESET_PASSWORD",
  PASSWORD_NOT_EQUAL: "Password not matched!",
  RESTAURANT_EXTERNAL_ID: "RestaurantExternalId",
  UPDATE_PASSWORD: "UPDATE_PASSWORD",
  SEND_HELP_MESSAGE: "SEND_HELP_MESSAGE",
  PHONE_NUMBER_EXIST: "Phone number already exist.",
  USER_PROFILE_IMG: "USER_PROFILE_IMG",
  BRAND_NAME: "Brand Name",
  UPDATE_BRAND_FEATURE_FLAGS: "UPDATE_BRAND_FEATURE_FLAGS",
  UPDATE_STORE_FEATURE_FLAGS: "UPDATE_STORE_FEATURE_FLAGS",
  UPDATE_CLARITY_CONSENT: "UPDATE_CLARITY_CONSENT",
  GET_ALL_BRANDS_WITH_FEATURE_FLAGS: "GET_ALL_BRANDS_WITH_FEATURE_FLAGS",
};

export const loginViewConstants = {
  FR_ROUTE: "FR-Route",
};

export const LoginRoles = {
  USER: "User",
  GROUP: "Group",
  MANAGER: "Manager",
  SUPER_ADMIN: "SuperAdmin",
  BRAND_ADMIN: "BrandAdmin",
};
